<adapt-render-expanded-zone-map [expandedZoneLocationTemplate]="zoneContentTemplate"
                                [globalZoneLocationTemplate]="globalZoneLocationTemplate"
                                [showGlobalZoneLocation]="showGlobalZoneLocation"
                                [globalZoneLocationLabel]="globalZoneLocationLabel"
                                [showResearchAndDevelopment]="showResearchAndDevelopment$ | async"
                                [showEconomicEngine]="showEconomicEngine$ | async"
                                [isEditing]="isEditing"></adapt-render-expanded-zone-map>

<ng-template #zoneContentTemplate
             let-zone="zone">
    <adapt-list-entities-in-location [zone]="zone"
                                     [filterTeams]="filterTeams"
                                     [isEditing]="isEditing"
                                     [teamTemplate]="teamTemplate"></adapt-list-entities-in-location>
</ng-template>
